import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ServiceCardProps {
  id: number;
  title: string;
  description: string;
  icon: string;
}
export interface ServiceCardType {
  service: ServiceCardProps;
  minHeight?: string;
  maxHeight?: string;
}

const ServiceCard: React.FC<ServiceCardType> = ({
  service,
  minHeight = '280px',
  maxHeight = '280px',
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`bg-white rounded-full shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:scale-105 flex flex-col`}
      style={{ maxHeight: maxHeight, minHeight: minHeight }}
    >
      <div className="p-6 md:p-8 flex-1 flex flex-col">
        <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center mb-6 mx-auto">
          <i
            className={`${service.icon} text-blue-600 text-xl md:text-2xl`}
          ></i>
        </div>
        <h3
          className={
            'text-xl md:text-2xl font-bold text-gray-900 mb-4 text-center'
          }
        >
          {t(service.title)}
        </h3>
        <p
          className={
            'text-gray-600 mb-6 text-center flex-1 text-sm md:text-base leading-relaxed'
          }
        >
          {t(service.description)}
        </p>
      </div>
    </div>
  );
};

export default ServiceCard;
